import React from 'react';
import { FOUP } from '../../FOUP/FOUP';
import { resolveFoupKindColor } from '../../types';

export type FoupProps = {
  position?: [number, number, number];
  rotation?: [number, number, number];
  /** Uniform kit scale — same value as OHT carrier and stocker load port. */
  scale?: number;
  status?: 'raw' | 'processed' | 'empty';
  opacity?: number;
};

/**
 * Equipment FOUP — thin wrapper around the shared kit mesh so OHT drop, load
 * deck, lifter, and chamber all render the same carrier at the same scale.
 * Origin: bottom-center of the clear kinematic base (matches OHT hoist math).
 */
export const Foup: React.FC<FoupProps> = ({
  position = [0, 0, 0],
  rotation = [0, 0, 0],
  scale = 1,
  status = 'raw',
  opacity = 1,
}) => (
  <FOUP
    position={position}
    rotation={rotation}
    scale={scale}
    opacity={opacity}
    color={
      status === 'empty'
        ? '#2A3038'
        : resolveFoupKindColor(status === 'processed' ? 'processed' : 'raw')
    }
  />
);

export default Foup;
